import UUIDBase from '../UUIDBase'
import { useI18nInstance, localizeFieldName } from '@/plugins/i18n'

const { t } = useI18nInstance().global

export const attributeI18nMessages = {
  en: {
    enName: 'Name (in Enlgish)',
    arName: 'Name (in Arabic)'
  },
  ar: {
    enName: 'الاسم باللغة الانكليزية',
    arName: 'الاسم باللغة العربية'
  }
}

export default class Attribute extends UUIDBase {
  static ENDPOINT = '/inventory/attributes'

  enName = ''
  arName = ''
  attributeID = ''
  attributeValue = ''

  static from(json: Record<string, unknown> | Attribute) {
    return Object.assign(new Attribute(), json)
  }

  validateEnName() {
    if (this.enName.length === 0) {
      return t('validation.required', {
        field: localizeFieldName('enName', attributeI18nMessages)
      })
    } else if (this.enName.length > 255) {
      return t('validation.maxLength', {
        field: localizeFieldName('enName', attributeI18nMessages)
      })
    }
  }

  validateArName() {
    if (this.arName.length === 0) {
      return t('validation.required', {
        field: localizeFieldName('arName', attributeI18nMessages)
      })
    } else if (this.arName.length > 255) {
      return t('validation.maxLength', {
        field: localizeFieldName('arName', attributeI18nMessages)
      })
    }
  }
}
